import { render, staticRenderFns } from "./SectionReceivedTaxInvoice.vue?vue&type=template&id=d450ad8c&scoped=true&"
import script from "./SectionReceivedTaxInvoice.vue?vue&type=script&lang=ts&"
export * from "./SectionReceivedTaxInvoice.vue?vue&type=script&lang=ts&"
import style0 from "./SectionReceivedTaxInvoice.vue?vue&type=style&index=0&id=d450ad8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d450ad8c",
  null
  
)

export default component.exports